import { useMemo, useState } from "react";
import { acceptGroupInvite } from "../api/groups";

export default function AcceptGroupInvitePage() {
  const initialToken = useMemo(() => {
    const url = new URL(window.location.href);
    return url.searchParams.get("token") || "";
  }, []);

  const [token, setToken] = useState(initialToken);
  const [statusMsg, setStatusMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleAccept() {
    const trimmed = String(token || "").trim();
    if (!trimmed) {
      setStatusMsg("Token is required.");
      return;
    }

    setBusy(true);
    setStatusMsg(null);
    try {
      const res = await acceptGroupInvite({ token: trimmed });
      setStatusMsg(`Invite accepted. Joined group ${res?.groupId || ""}`.trim());
    } catch (e: any) {
      setStatusMsg(e?.message || "Could not accept invite.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Accept group invite</div>
          <div className="page-subtitle">Paste an invite token or open this page with a token query param.</div>
        </div>
      </div>

      <div className="card">
        <div className="section">
          <div className="section-title">Invite token</div>
          <input
            className="form-input"
            style={{ minWidth: 360 }}
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Paste invite token"
          />
          <div className="chip-row" style={{ marginTop: 10 }}>
            <button className="btn-primary" onClick={() => void handleAccept()} disabled={busy}>
              {busy ? "Accepting…" : "Accept invite"}
            </button>
            <a className="btn-outline" href="/groups">
              Browse groups
            </a>
          </div>
          {statusMsg && (
            <p className="text-muted small" style={{ marginTop: 10 }}>
              {statusMsg}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
